import { render, staticRenderFns } from "./BookingReceipt.vue?vue&type=template&id=f6e581d2&scoped=true"
import script from "./BookingReceipt.vue?vue&type=script&lang=js"
export * from "./BookingReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e581d2",
  null
  
)

export default component.exports